import React, { useMemo } from "react";
import { Document, DocumentProps, Page } from "react-pdf";

import { Size } from "../../../../store/types";

interface DocumentWrapperProps {
  file: File;
  originalScale: number;
  userScale: number;
  pageNumber: number;
  setPageSize: (size: Size) => void;
  setOriginalScale: (scale: number) => void;
  onDocumentLoadSuccess: DocumentProps["onLoadSuccess"];
  isReadOnly?: boolean;
  pageWidth?: number;
}

const DocumentWrapper = React.memo((props: DocumentWrapperProps) => {
  const options = useMemo(
    () => ({ normalizeWhitespace: true }) as React.ComponentProps<typeof Document>["options"],
    []
  );
  const PAGE_WIDTH = props.pageWidth ?? (props.isReadOnly ? 600 : window.innerWidth * 0.7);

  return (
    <Document
      file={props.file}
      options={options}
      renderMode="canvas"
      // onItemClick={({ pageNumber }) => alert(pageNumber)}
      onLoadSuccess={props.onDocumentLoadSuccess}
    >
      <Page
        scale={props.originalScale * props.userScale}
        onLoadSuccess={(page) => {
          props.setPageSize({ width: page.originalWidth, height: page.originalHeight });
          props.setOriginalScale(PAGE_WIDTH / page.originalWidth);
        }}
        pageNumber={props.pageNumber}
        renderTextLayer={false}
        renderAnnotationLayer={false}
      />
    </Document>
  );
});

export default DocumentWrapper;
